module.exports = __webpack_public_path__ + "static/img/newshh.88932ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newshh.png
// module id = MVkv
// module chunks = 45